import { render, staticRenderFns } from "./SpotRoleAggregationWidgetCounterControl.global.vue?vue&type=template&id=04b4248a&lang=pug&"
import script from "./SpotRoleAggregationWidgetCounterControl.global.vue?vue&type=script&lang=ts&"
export * from "./SpotRoleAggregationWidgetCounterControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports